module.exports = __webpack_public_path__ + "img/app_qr_my.a6edbbba.png";